import { AuthConfig, FCMNotificationActionGroupEnum } from './../../../Services/auth.service';
import { ConnectionsService, InviteExternalUserData } from '../../../Services/connections.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { AuthService, ResponseObject } from '../../../Services/auth.service';
import { Consignment, ConsignmentService } from 'src/app/Services/consignment.service';
import { NotificationTypes } from 'src/app/app.enums';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { Artist } from 'src/app/Services/artists.service';
import { InviteCommentRequest } from '../../artist-components/connected-galleries/connected-galleries.component';
import { ArtistProductsSummaryRequest } from 'src/app/Services/artistproducts.service';
import { ChatUser } from 'src/app/models/chatBox.model';
import { StripePlans } from 'src/app/models/stripe.model';
import { MessagingService } from 'src/app/Services/messaging.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'connected-artists',
    templateUrl: './connected-artists.component.html',
    styleUrls: ['./connected-artists.component.css'],
    providers: [ConnectionsService, ConsignmentService, SubscriptionRulesService],
    standalone: false
})
export class ConnectedArtistsComponent implements OnInit {
  public artistId: string | null = null;
  public connectedId: string | null = null;
  public galleryId!: string;
  public connectedArtist: Artist[] = [];
  public connectedArtists!: Artist;

  public avalableGallery: SelectItem[] = [];
  public avalableArtist: SelectItem[] = [];
  public inviteExternalUserData!: InviteExternalUserData;
  public sendInvite: any;
  public artistConsignmentForGallery: Consignment[] = [];
  public inviteDialogVisible = false;
  public inviteExternalUserDialogVisible = false;
  public userSubscription: string = '';
  public allowedToSendInvitations: boolean = false;
 public isStripeDisplayPlansDialogVisible : boolean = false
  public stripePlans: StripePlans[] = [];
    public authConfig: AuthConfig = {};
  public formData!: InviteCommentRequest;
  public selectedUserId: string | null = null;
  public displayEmojiDialog: boolean = false;
  public selectedCommentField: 'internal' | 'external' | null = null;
  public isLoading: boolean = true;
  public searchTerm: string = '';

  /** Client-side search over the loaded connected artists (name / email / phone / business). */
  public get displayedArtists(): Artist[] {
    const q = this.searchTerm.trim().toLowerCase();
    if (!q) { return this.connectedArtist; }
    return this.connectedArtist.filter(a =>
      (a.Name || '').toLowerCase().includes(q) ||
      (a.Email || '').toLowerCase().includes(q) ||
      (a.PhoneNumber || '').toLowerCase().includes(q) ||
      (a.BusinessName || '').toLowerCase().includes(q));
  }

  constructor(private confirmationService: ConfirmationService,
    private ngxSpinnerService: NgxSpinnerService,
    private connectionsService: ConnectionsService,
    private subscriptionRulesService: SubscriptionRulesService,
    private notificationService: NotificationsService,
    private consignmentService: ConsignmentService,
    private router: Router,
    private messagingService: MessagingService,
    private route: ActivatedRoute,
    private transloco: TranslocoService,
    private authService: AuthService) {
    this.inviteExternalUserData = new InviteExternalUserData();
    this.formData = new InviteCommentRequest();
  }

  public ngOnInit(): void {
    this.reciveNotifications()   
     this.route.params.subscribe((params) => {
      this.route.queryParams.subscribe(params => {
        this.selectedUserId = params['userId'] || '';
      });
    });
    this.authConfig = this.authService.getAuthConfig();

    if (this.authService.isGallery()) {
      this.galleryId = this.authService.getUserId();
      this.getConnectedArtists(this.galleryId);
      this.canSendMoreInvites();
    }
    else if (this.authService.isGalleryStaff()) {
      this.galleryId = this.authService.getParrentGalleryId();
      this.getConnectedArtists(this.galleryId);
      this.canSendMoreInvites();
    }
  }

  public reciveNotifications() {
    this.messagingService.handleMarkasReadByActionType(FCMNotificationActionGroupEnum.Connection);
   }

  
  public reciveMessages() {
    this.messagingService.currentMessage.subscribe((data: any) => {
      if (!data) return; 
      this.messagingService.receiveMessage();
    });
  }


  public openInviteDialog($event: any) {
    if (!this.allowedToSendInvitations) {
      //if the artist is not allowed to send any more invitations, show the subscirption dialog
      this.displayUpgreadAccountDialog = true;
      return;
    }

    this.artistId = null;
    this.inviteDialogVisible = true;
    this.availableArtists();
  }

  public openInviteExternalUserDialog($event: any) {
    this.inviteExternalUserDialogVisible = true;
  }

  public onCloseStripePaymentDailog($event: boolean) {
    this.displayUpgreadAccountDialog = $event;
  }

  private availableArtists() {
    this.ngxSpinnerService.show();
    this.connectionsService.getAvailableArtists(this.galleryId).subscribe((res) => {
      this.avalableArtist = res;
      this.ngxSpinnerService.hide();
    }, (error) => { console.error('Error fetching connected artists:', error); this.ngxSpinnerService.hide(); });
  }


  public onArtistSelection($event: any) {
    this.artistId = $event.value;
    console.log(this.artistId);

  }

  public statusFilterOptions: SelectItem[] = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Accepted', value: 'Accepted' },
    { label: 'Sending', value: 'Sending' },
  ];
  public filters: ArtistProductsSummaryRequest = {};

  public onStatusFilterChange($event: any) {
    this.filters.ConnectionStatus = $event.value;
    this.getConnectedArtists(this.galleryId, this.filters);
  }
  private getConnectedArtists(galleryId: string | null = null, filters: ArtistProductsSummaryRequest = {}) {
    this.isLoading = true;
    this.ngxSpinnerService.show();
    this.connectionsService.getConnectedArtists(galleryId, true, filters).subscribe((data: Artist[]) => {
      this.connectedArtist = data;
      console.log('connectedArtist', this.connectedArtist)
      this.ngxSpinnerService.hide();
      this.isLoading = false;
    }, (error) => { console.error('Error fetching connected Artist:', error); this.ngxSpinnerService.hide(); this.isLoading = false; });
  }

  public notesDialogVisible: boolean = false;

  public closeNotesDialog($event: any) {
    this.notesDialogVisible = false;
  }
  public openNotesDialog($event: any) {
    this.notesDialogVisible = true;
    this.connectedArtists = $event
    console.log('$event', this.connectedArtists)
  }




  private canSendMoreInvites() {
    this.subscriptionRulesService.canSendMoreInvites().subscribe((isAllowed: boolean) => {
      this.allowedToSendInvitations = isAllowed;
    }, (error) => { console.error(error); });
  }

  public sendInvitation() {
    this.ngxSpinnerService.show();
    console.log(this.artistId);
    this.connectionsService.sendInvite(this.artistId, this.galleryId, this.formData).subscribe((res: ResponseObject) => {
      if (res.Success) {
        this.ngxSpinnerService.hide();
        this.inviteDialogVisible = false;
        this.artistId = null;
        this.getConnectedArtists(this.galleryId);
        this.notificationService.showNotification(this.transloco.translate('connectedArtists.success'), this.transloco.translate('connectedArtists.invitationSentSuccessfully'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('connectedArtists.error'), res.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error('Error fetching For invitation:', error); this.ngxSpinnerService.hide(); });
  }

  public inviteExternalUser() {
    this.ngxSpinnerService.show();
    this.connectionsService.inviteExternalUser(this.inviteExternalUserData).subscribe((res: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (res.Success) {
        this.inviteExternalUserDialogVisible = false;
        this.artistId = null;
        this.availableArtists();
        this.notificationService.showNotification(this.transloco.translate('connectedArtists.success'), this.transloco.translate('connectedArtists.invitationSentSuccessfully'), NotificationTypes.Success);
      } else { this.notificationService.showNotification(this.transloco.translate('connectedArtists.error'), res.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error('Error fetching For invitation:', error); this.ngxSpinnerService.hide(); });
  }

  public openEmojiDialog(commentField: 'internal' | 'external') {
    this.selectedCommentField = commentField;
    this.displayEmojiDialog = true;
  }
  
  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    if (this.selectedCommentField === 'internal') {
      this.formData.InviteArtistComment = (this.formData.InviteArtistComment || '') + emoji;
    } else if (this.selectedCommentField === 'external') {
      this.inviteExternalUserData.InviteExternalComment = (this.inviteExternalUserData.InviteExternalComment || '') + emoji;
    }
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }


  public deleteConnectedArtist(rowData: Artist) {
    this.confirmationService.confirm({
      message: this.transloco.translate('connectedArtists.confirmDeleteArtist', { name: rowData.Name }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.connectionsService.deleteConnectedArtist(rowData.Id!).subscribe((res: ResponseObject) => {
          this.ngxSpinnerService.hide();
          if (res.Success) {
            this.getConnectedArtists(this.galleryId);
            this.notificationService.showNotification(this.transloco.translate('connectedArtists.success'), this.transloco.translate('connectedArtists.artistDeletedSuccessfully'), NotificationTypes.Success);
          } else { this.notificationService.showNotification(this.transloco.translate('connectedArtists.error'), res.ResponseMessage, NotificationTypes.Error); }
        }, (error) => { console.error('Error deleting connected artist:', error); this.ngxSpinnerService.hide(); this.notificationService.showNotification(this.transloco.translate('connectedArtists.error'), this.transloco.translate('connectedArtists.errorDeletingArtist'), NotificationTypes.Error); });
      }
    });
  }

  public navigateToViewArtist(rowData: Artist) {
    if (!this.authConfig.IsGalleryStaff) {
      if (rowData.IsInviteAccepted) {
        this.router.navigate(['/artist', rowData.Id]);
      } else if (rowData.IsInitiatedByArtist && !rowData.IsInviteAccepted) {
        this.router.navigate(['/connection-request', rowData.ConnectionId]);
      } else {
        this.router.navigate(['/profile', rowData.UserName]);
      }
    }

  }

  public goToConnectionRequestDetail(rowData: Artist) {
    this.router.navigate(['/connection-request', rowData.ConnectionId]);
  }
  public ChatwithArtist(user: ChatUser) {
    this.router.navigate(['/inbox', user.Id]);
  }
public displayUpgreadAccountDialog : boolean = false
  
  public onUpgradeAccount() {
    this.isStripeDisplayPlansDialogVisible = true;
  }
}




 